import * as React from 'react'

function IconLeaf6(props: React.SVGProps<SVGSVGElement>) {
  return (
    <svg
      width={66}
      height={47}
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
      {...props}
    >
      <path
        d="M55.29 42.989L13.25 12.513l52.671 24.46S50.533-14.42.497 5.298c.004-.017 9.927 54.222 54.792 37.69z"
        fill="#F4BA27"
      />
    </svg>
  )
}

export default IconLeaf6
